import consumer from "./consumer"
import { reloadFrame } from "../util"

const UserChannel = consumer.subscriptions.create("UserChannel", {
  connected() {
    console.log("Connected to UserChannel")
  },

  disconnected() {
    console.log("Disconnected from UserChannel")
  },

  received(data) {
    if (data.event === "chat_updated") {
      this.updateDialogsList()
    } else if (data.event === "admission_process_stage_updated") {
      this.reloadWindow()
    } else if (data.type === "video_upload_progress") {
      this.handleVideoUploadProgress(data)
    } else if (data.type === "video_upload_completed") {
      this.handleVideoUploadCompleted(data)
    } else if (data.type === "video_upload_failed") {
      this.handleVideoUploadFailed(data)
    } else if (data.type === "university_deletion_progress") {
      this.handleUniversityDeletionProgress(data)
    } else if (data.type === "university_deletion_finished") {
      this.handleUniversityDeletionFinished(data)
    }
  },

  updateDialogsList() {
    reloadFrame("dialogs_list")
  },

  reloadWindow() {
    window.location.reload()
  },

  handleVideoUploadProgress(data) {
    const event = new CustomEvent("video:upload:progress", {
      detail: {
        videoId: data.video_id,
        percentage: data.percentage,
        uploadedBytes: data.uploaded_bytes,
        totalBytes: data.total_bytes
      }
    })
    window.dispatchEvent(event)
  },

  handleVideoUploadCompleted(data) {
    this.recordVideoUploadStatus(data.video_id, { type: "completed", videoUrl: data.video_url })

    const event = new CustomEvent("video:upload:completed", {
      detail: {
        videoId: data.video_id,
        videoUrl: data.video_url
      }
    })
    window.dispatchEvent(event)
  },

  handleVideoUploadFailed(data) {
    this.recordVideoUploadStatus(data.video_id, { type: "failed", error: data.error })

    const event = new CustomEvent("video:upload:failed", {
      detail: {
        videoId: data.video_id,
        error: data.error
      }
    })
    window.dispatchEvent(event)
  },

  recordVideoUploadStatus(videoId, status) {
    window.videoUploadStatuses = window.videoUploadStatuses || {}
    window.videoUploadStatuses[videoId] = status
  },

  handleUniversityDeletionProgress(data) {
    const event = new CustomEvent("university:deletion:progress", {
      detail: {
        universityId: data.university_id,
        percentage: data.percentage
      }
    })
    window.dispatchEvent(event)
  },

  handleUniversityDeletionFinished(data) {
    const event = new CustomEvent("university:deletion:finished", {
      detail: {
        universityId: data.university_id
      }
    })
    window.dispatchEvent(event)
  }
})

export default UserChannel
